import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var ColumnWidthIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 12" }),
        React.createElement("path", { d: "M2.22 11.1667H1.33333C0.6 11.1667 0 10.5667 0 9.83333V1.83333C0 1.1 0.6 0.5 1.33333 0.5H2.22C2.95333 0.5 3.55333 1.1 3.55333 1.83333V9.83333C3.55333 10.5667 2.96 11.1667 2.22 11.1667ZM13.3333 9.83333V1.83333C13.3333 1.1 12.7333 0.5 12 0.5H11.1133C10.38 0.5 9.78 1.1 9.78 1.83333V9.83333C9.78 10.5667 10.38 11.1667 11.1133 11.1667H12C12.74 11.1667 13.3333 10.5667 13.3333 9.83333ZM8.44667 9.83333V1.83333C8.44667 1.1 7.84667 0.5 7.11333 0.5H6.22667C5.49333 0.5 4.89333 1.1 4.89333 1.83333V9.83333C4.89333 10.5667 5.49333 11.1667 6.22667 11.1667H7.11333C7.84667 11.1667 8.44667 10.5667 8.44667 9.83333Z" })));
};

export { ColumnWidthIcon };
//# sourceMappingURL=ColumnWidthIcon.esm.js.map
